/* eslint-disable @next/next/no-img-element */
//components
import { GhostLink } from '@/containers-ai/Buttons';

//data
import { OFFICES } from '@/datafiles/offices/address';

//styles
import {
  OfficeSection,
  OfficeRow,
  OfficeCopy,
  OfficeTitle,
  OfficeAddress,
  OfficeImage,
} from './Office.styles';

export function Office({ content }) {
  return (
    <OfficeSection>
      <OfficeRow>
        <OfficeCopy>
          <OfficeTitle>{content.title}</OfficeTitle>
          <OfficeAddress>
            <p>{content.name ?? OFFICES.main.label}</p>
            {content.addressLines ? (
              content.addressLines.map((line) => <span key={line}>{line}</span>)
            ) : (
              <>
                <span>{OFFICES.main.address}</span>
                <span>{`${OFFICES.main.city}, ${OFFICES.main.state} ${OFFICES.main.zipcode}`}</span>
              </>
            )}
          </OfficeAddress>
          <GhostLink
            href="https://maps.app.goo.gl/3yfHgLNzXQ8cu9PR6"
            target="_blank"
            rel="noreferrer noopener"
          >
            {content.ctaLabel}
          </GhostLink>
        </OfficeCopy>
        <OfficeImage
          src="/images/contact/office-photo.webp"
          alt={content.imageAlt ?? 'Loadsmart headquarters location on the map'}
          loading="lazy"
        />
      </OfficeRow>
    </OfficeSection>
  );
}
